import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MerchantService } from '../../../services/merchant.service';
import MerchantInterface from '../../../interfaces/merchant.interface';
import { AdminShellComponent } from '../../layout/admin-shell/admin-shell.component';
import { ConfirmDialogComponent } from '../../ui/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'app-list-merchant',
    imports: [CommonModule, AdminShellComponent, ConfirmDialogComponent],
    templateUrl: './list-merchant.component.html',
    styleUrls: ['./list-merchant.component.css']
})
export class ListMerchantComponent implements OnInit {
  merchants: MerchantInterface[] = [];
  // Distinguishes "still loading" / "loaded and empty" / "failed to load"
  // for the loading/empty/error states. getMerchants() now completes
  // (isLoading = false) on both success AND error, and hasError drives a
  // branded retry state instead of silently showing an empty table — this
  // was a pre-existing stability gap fixed as part of post-rebrand QA.
  isLoading = true;
  hasError = false;
  // Presentation-only: the merchant's public payment URL is displayed using
  // whatever host the app is actually running on (localhost while
  // developing, the deployed dev domain, or production) instead of a
  // hardcoded domain — matches the real route (`/merchant/:paymentLink`).
  merchantUrlHost = location.host;
  // Presentation-only: replaces the native browser confirm() for delete with
  // the branded ConfirmDialogComponent. Holding the merchant here (instead
  // of just a boolean) lets the dialog show its name; the actual delete
  // call/behavior in confirmDelete() below is unchanged from before.
  merchantPendingDelete: MerchantInterface | null = null;

  constructor(
    private merchantService: MerchantService,
    private http: HttpClient,
    private router: Router
  ) {}

  ngOnInit() {
    this.getMerchants();
  }

  getMerchants() {
    this.isLoading = true;
    this.hasError = false;
    this.merchantService.getMerchants().subscribe({
      next: (data) => {
        this.merchants = data;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error fetching merchants', error);
        this.hasError = true;
        this.isLoading = false;
      },
    });
  }

  editMerchant(id: string) {
    this.router.navigate(['/edit-merchant', id]);
  }

  requestDelete(merchant: MerchantInterface): void {
    this.merchantPendingDelete = merchant;
  }

  cancelDelete(): void {
    this.merchantPendingDelete = null;
  }

  confirmDelete(): void {
    const merchant = this.merchantPendingDelete;
    if (!merchant?.id) {
      return;
    }
    this.merchantPendingDelete = null;
    this.merchantService.deleteMerchant(merchant.id).subscribe(() => {
      this.getMerchants();
    });
  }

  addMerchant() {
    this.router.navigate(['/add-merchant']);
  }
}
